// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"276":"df226a6f","360":"0e81899c"}[chunkId] + ".js";
};